

const PlayScreenSkeleton = () => {
    return (
        <div className="flex flex-col justify-between h-full animate-pulse">
            <div className="h-4" />

            {/* Swipe Card Skeleton */}
            <div className="h-[220px] w-[90%] bg-gray-300/50 rounded-2xl mx-auto" />

            <div className="h-6" />

            {/* Step Cards */}
            <div className="w-full space-y-4 px-4 max-w-md mx-auto">
                <div className="rounded-2xl bg-gray-200/60 p-4 text-center space-y-2">
                    <div className="h-4 w-2/3 mx-auto bg-gray-300 rounded" />
                    <div className="h-4 w-1/2 mx-auto bg-gray-300 rounded" />
                    <div className="h-10 w-24 mx-auto bg-gray-300 rounded-full" />
                </div>

                <div className="rounded-2xl bg-gray-200/60 p-4 text-center space-y-3">
                    <div className="h-4 w-3/4 mx-auto bg-gray-300 rounded" />
                    <div className="h-10 w-1/2 mx-auto bg-gray-400 rounded-full" />
                </div>
            </div>

            <div className="h-4" />
        </div>
    );
};

export default PlayScreenSkeleton;

